import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiButtonGroup = ({ misc }: Pick<Tokens, 'misc'>) =>
  ({
    MuiButtonGroup: {
      defaultProps: {
        // we do not set the variant and color here, since we have yet to come to a decision on the actual ButtonGroup
        // variant: 'contained',
        // color: 'primary',
        // we have to also specify the disableRipple in here, in spite of our ButtonBase config...
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          borderRadius: misc.borderRadius(),
          textTransform: 'none',
          fontWeight: 'normal',
          boxShadow: 'none',
          ':hover': {
            boxShadow: 'none',
          },
          '& .MuiIconButton-root:not(:first-of-type)': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          '& .MuiIconButton-root:not(:last-of-type)': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          borderColor: 'unset',
        },
        firstButton: {
          borderRight: 'unset',
          '&.Mui-disabled': {
            borderRight: 'unset',
          },
        },
        grouped: {
          minWidth: spacing(20),
        },
        middleButton: {
          borderRight: 'unset',
          '&.Mui-disabled': {
            borderRight: 'unset',
          },
        },
      },
    },
  }) satisfies ComponentCreation
